import axios, { AxiosInstance } from 'axios';
import getAppRefreshToken from 'service/refresh-token';
import {
  getAuthAccessToken,
  setStoredRefreshToken,
} from 'core/storage/authSessionStorage';
import { HttpStatusCode } from 'constants/globals';
import service from 'service/auth';

export const createSecureInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(
    (config) => {
      const token = getAuthAccessToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const refreshToken = service.getRefreshToken();

      const { status, data } = error.response || {};

      if (
        (status === HttpStatusCode.InternalServerError &&
          data?.error?.internal_error?.includes('validar el token')) ||
        status === HttpStatusCode.Unauthorized
      ) {
        service.doLogin();
      }

      if (
        status === HttpStatusCode.Unauthorized &&
        !originalRequest._retry &&
        refreshToken
      ) {
        originalRequest._retry = true;

        const response = await getAppRefreshToken();
        const { access_token, refresh_token } = response.data;

        axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;

        setStoredRefreshToken(refresh_token);

        return instance(originalRequest);
      }

      return Promise.reject(error);
    },
  );

  return instance;
};
